// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1pxFU","unreadBadge":"styles_unreadBadge__b9HWo","modalContent":"styles_modalContent__2cA5K","modal":"styles_modal__2wkrs"};